import { KeyboardEvent, useMemo } from "react";
import useOnKeyHandler from "./useOnKeyHandler";

// Returns a callback that triggers onActivate when space or enter is pressed.
export default function useButtonActivateHandler<T = Element>(
  onActivate: () => void
): (event: KeyboardEvent<T>) => void {
  return useOnKeyHandler<T>(
    useMemo(() => new Set([" ", "Enter"]), []),
    onActivate
  );
}
